import type { Role } from "@/api/models";
export type { Role } from "@/api/models";

export function isAdminRole(role: Role | undefined): boolean {
  return role === "chief" || role === "respai_admin";
}

/** Human label for a role. A user can hold several (e.g. chief + IC). */
export function roleLabel(role: Role): string {
  switch (role) {
    case "respai_admin":
      return "Admin";
    case "respai_sales":
      return "Sales";
    case "chief":
      return "Chief";
    case "incident_commander":
      return "Incident commander";
    case "firefighter":
      return "Firefighter";
  }
}

export function isRespaiAdmin(role: Role | undefined): boolean {
  return role === "respai_admin";
}

/**
 * The sandbox capability (RES-155): respai_sales can generate/manage demo
 * sandboxes but — by construction, no rls_bypass — read no customer tenant.
 * respai_admin is included so platform staff can operate the same surface.
 */
export function canManageSandboxes(role: Role | undefined): boolean {
  return role === "respai_sales" || role === "respai_admin";
}

/** A sales-only login: allowed into the app solely for the sandbox surface. */
export function isSalesOnly(role: Role | undefined): boolean {
  return role === "respai_sales";
}

export function canEditReport(role: Role | undefined): boolean {
  return isAdminRole(role);
}

export function canManageUsers(role: Role | undefined): boolean {
  return isAdminRole(role);
}
